
import { useState } from 'react';

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '최소 투자 금액은 얼마인가요?',
      answer: 'Early Bird 패키지의 경우 최소 $1,000부터 투자 가능하며, 가장 인기 있는 Growth Investor 패키지는 $10,000부터 시작됩니다. 각 패키지별로 다양한 혜택과 지분율이 제공됩니다.'
    },
    {
      question: '투자 수익은 언제부터 기대할 수 있나요?',
      answer: '초기 수익은 제품 출시 후인 2024년 4분기부터 예상되며, 본격적인 수익 창출은 2025년부터 시작될 예정입니다. 연간 30% 이상의 ROI를 목표로 하고 있습니다.'
    },
    {
      question: '투자자는 어떤 권리를 갖게 되나요?',
      answer: '투자 금액에 따라 지분 소유, 의결권 행사, 정기 보고서 수령, 제품 우선 구매권 등의 권리를 갖습니다. Strategic Partner 이상의 경우 경영진과의 직접 미팅 기회도 제공됩니다.'
    },
    {
      question: '투자금은 어떻게 사용되나요?',
      answer: '투자금의 40%는 연구개발, 30%는 생산 시설 확장, 20%는 마케팅 및 영업, 10%는 운영자금으로 사용됩니다. 모든 자금 사용 내역은 투자자들에게 투명하게 공개됩니다.'
    },
    {
      question: '회사의 기술적 우위는 무엇인가요?',
      answer: '독자 개발한 해양 미생물 발효 기술과 나노 바이오 소재 합성 기술로 12건의 국제 특허를 보유하고 있습니다. 이는 기존 석유 기반 소재 대비 생분해 속도가 10배 빠른 혁신적 기술입니다.'
    },
    {
      question: '규제 승인 현황은 어떻게 되나요?',
      answer: '현재 FDA 승인 절차를 진행 중이며, 이미 ISO 14001 환경경영시스템 인증을 획득했습니다. 유럽 CE 마킹과 한국 KC 인증도 동시에 추진하고 있어 글로벌 시장 진출 준비가 완료되었습니다.'
    },
    {
      question: '경쟁사 대비 우위점은 무엇인가요?',
      answer: '기존 바이오 소재 기업들은 주로 육상 기반 원료를 사용하지만, 저희는 해양 자원을 활용해 더 뛰어난 성능과 환경 친화성을 실현했습니다. 또한 생산 비용도 30% 이상 절감할 수 있습니다.'
    },
    {
      question: '투자 철회나 지분 매각이 가능한가요?',
      answer: '일반적으로 스타트업 투자는 장기 투자이지만, Series B 라운드 시점부터 기존 투자자들에게 부분 매각 기회를 제공할 예정입니다. IPO 시점에는 보다 자유로운 매매가 가능합니다.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            자주 묻는 질문
          </h2>
          <p className="text-xl text-gray-600">
            투자 전 궁금한 사항들을 확인해보세요.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 text-left hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition-colors cursor-pointer"
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </h3>
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl text-blue-600 flex-shrink-0`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <div className="pt-2 border-t border-gray-100">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* 추가 문의 */}
        <div className="mt-12 text-center bg-blue-600 text-white rounded-xl p-8">
          <h3 className="text-2xl font-bold mb-4">
            더 궁금한 점이 있으신가요?
          </h3>
          <p className="text-blue-100 mb-6">
            투자 관련 상세한 문의사항은 언제든지 연락주세요.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="mailto:invest@marinebiogroup.com"
              className="inline-flex items-center justify-center px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-blue-50 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              invest@marinebiogroup.com
            </a>
            <a 
              href="tel:+1-571-531-8278"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-600 transition-colors cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              +1-571-531-8278
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
